{
  "slTp": {
    "price": "Price",
    "stopLossShort": "SL",
    "stopLoss": "Stop Loss",
    "takeProfitShort": "TP",
    "takeProfit": "Take Profit",
    "close": "Close"
  }
}
